export class RAP {
  positiveResponseCount: number;

  negativeResponseCount: number;

  adjustedPositiveResponseCount: number;

  adjustedPositiveRepeatResponseCount: number;

  adjustedNegativeResponseCount: number;

  totalResponseCount: number;

  offerCount: number;

  lastUpdated: string;

  offerLastUpdated: string;

  positiveResponseRate: number;

  adjustedPositiveResponseRate: number;

  responseRate: number;

  negativeResponseRate: number;

  constructor({
    positiveResponseCount,
    negativeResponseCount,
    adjustedPositiveResponseCount,
    adjustedPositiveRepeatResponseCount,
    adjustedNegativeResponseCount,
    totalResponseCount,
    offerCount,
    lastUpdated,
    offerLastUpdated,
    positiveResponseRate,
    adjustedPositiveResponseRate,
    responseRate,
    negativeResponseRate,
  }: Record<string, any>) {
    this.positiveResponseCount = positiveResponseCount;
    this.negativeResponseCount = negativeResponseCount;
    this.adjustedPositiveResponseCount = adjustedPositiveResponseCount;
    this.adjustedPositiveRepeatResponseCount =
      adjustedPositiveRepeatResponseCount;
    this.adjustedNegativeResponseCount = adjustedNegativeResponseCount;
    this.totalResponseCount = totalResponseCount;
    this.offerCount = offerCount;
    this.lastUpdated = lastUpdated;
    this.offerLastUpdated = offerLastUpdated;
    this.positiveResponseRate = positiveResponseRate;
    this.adjustedPositiveResponseRate = adjustedPositiveResponseRate;
    this.responseRate = responseRate;
    this.negativeResponseRate = negativeResponseRate;
  }
}

export const EmptyRAP: RAP = {
  positiveResponseCount: 0,
  negativeResponseCount: 0,
  adjustedPositiveResponseCount: 0,
  adjustedPositiveRepeatResponseCount: 0,
  adjustedNegativeResponseCount: 0,
  totalResponseCount: 0,
  offerCount: 0,
  lastUpdated: '',
  offerLastUpdated: '',
  positiveResponseRate: 0,
  adjustedPositiveResponseRate: 0,
  responseRate: 0,
  negativeResponseRate: 0,
};
